// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomFiSrSad = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '10',
      height: '11',
      viewBox: '0 0 10 11',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#clip0_2125_37280)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M5 0.5C4.01109 0.5 3.0444 0.793245 2.22215 1.34265C1.3999 1.89206 0.759043 2.67295 0.380605 3.58658C0.00216643 4.50021 -0.0968502 5.50555 0.0960758 6.47545C0.289002 7.44536 0.765206 8.33627 1.46447 9.03553C2.16373 9.7348 3.05465 10.211 4.02455 10.4039C4.99446 10.5969 5.99979 10.4978 6.91342 10.1194C7.82705 9.74096 8.60794 9.1001 9.15735 8.27785C9.70676 7.4556 10 6.48891 10 5.5C9.99857 4.17436 9.47132 2.90342 8.53395 1.96605C7.59658 1.02868 6.32564 0.501434 5 0.5V0.5ZM3.33333 3.83333C3.55435 3.83333 3.76631 3.92113 3.92259 4.07741C4.07887 4.23369 4.16667 4.44565 4.16667 4.66667C4.16667 5.08333 3.79375 5.08333 3.33333 5.08333C2.87292 5.08333 2.5 5.08333 2.5 4.66667C2.5 4.44565 2.5878 4.23369 2.74408 4.07741C2.90036 3.92113 3.11232 3.83333 3.33333 3.83333ZM7.39417 7.86125C7.32066 7.9435 7.21753 7.99324 7.10739 7.99957C6.99726 8.0059 6.88911 7.96829 6.80667 7.895C6.29728 7.46618 5.66438 7.21104 5 7.16667C4.33561 7.21098 3.7027 7.46613 3.19333 7.895C3.11079 7.96849 3.00243 8.00617 2.89209 7.99976C2.78176 7.99336 2.67849 7.94338 2.605 7.86083C2.53151 7.77828 2.49383 7.66992 2.50024 7.55959C2.50664 7.44926 2.55662 7.34599 2.63917 7.2725C3.30078 6.70728 4.13093 6.37704 5 6.33333C5.86908 6.37704 6.69922 6.70728 7.36083 7.2725C7.40172 7.30895 7.43501 7.35309 7.45882 7.40242C7.48262 7.45175 7.49647 7.50528 7.49956 7.55996C7.50266 7.61465 7.49494 7.6694 7.47686 7.7211C7.45877 7.7728 7.43067 7.82042 7.39417 7.86125ZM6.66667 5.08333C6.20625 5.08333 5.83333 5.08333 5.83333 4.66667C5.83333 4.44565 5.92113 4.23369 6.07741 4.07741C6.23369 3.92113 6.44565 3.83333 6.66667 3.83333C6.88768 3.83333 7.09964 3.92113 7.25592 4.07741C7.4122 4.23369 7.5 4.44565 7.5 4.66667C7.5 5.08333 7.12708 5.08333 6.66667 5.08333Z',
        fill: 'currentColor',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_2125_37280',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: '10',
          height: '10',
          fill: 'white',
          transform: 'translate(0 0.5)',
        }),
      ),
    ),
  );

export { IconCustomFiSrSad };
